// Keep in sync with ALLOWED_CONTENT_TYPES / MAX_FILE_SIZE_BYTES in src/api/audit-files.ts.
// The server re-validates both — this is UX only (input filter + early client-side message).
export const ACCEPTED_AUDIT_FILE_TYPES = [
  "image/png",
  "image/jpeg",
  "image/webp",
  "image/gif",
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "text/csv",
  "text/plain",
  "application/zip",
].join(",");

export const MAX_AUDIT_FILE_SIZE_BYTES = 25 * 1024 * 1024;
